export const headerHeight = '118px';
export const mobileHeaderHeight = '100px';
export const mobileMenuWidth = '256px';
